/*
 * View for the strength gauge
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicExampleModal/strengthGauge/template/strengthGaugeTemplate.html",
], function (Marionette, StrengthGaugeTemplate) {
  var StrengthGaugeView = {};

  StrengthGaugeView.strengthGaugeView = Marionette.ItemView.extend({
    template: StrengthGaugeTemplate,
    modelEvents: {
      sync: "render",
      change: "render",
    },
    onRender: function () {
      this.$el.i18n();
      this.setStrength(this.model.get("strength"));
    },
    setStrength: function (strength) {
      //set selected gauge mark
      if (strength <= 25) {
        //enable "bad" mark
        this.$el.find(".gauge1").addClass("selected");
        this.$el.find("li").removeClass().addClass("alert alert-error");
      } else if (strength <= 50) {
        //enable "weak" mark
        this.$el.find(".gauge2").addClass("selected");
        this.$el.find("li").removeClass().addClass("alert alert-warning");
      } else if (strength <= 75) {
        //enable "good" mark
        this.$el.find(".gauge3").addClass("selected");
        this.$el.find("li").removeClass().addClass("alert alert-success");
      } else {
        //enable "great" mark
        this.$el.find(".gauge4").addClass("selected");
        this.$el.find("li").removeClass().addClass("alert alert-success");
      }
      //move tick mark to the correct strength (need to shift it by 2% for correct alignment)
      this.$el.find(".tick").css("left", strength - 2 + "%");
    },
  });

  return StrengthGaugeView;
});
